export const ENDPOINTS_PATH_NAME = 'endpoints';

export const ENDPOINT_DETECTIONS_MAX_ITEMS = 100;

export const ENDPOINT_RELATED_WEBPAGES_DEFAULT_LIMIT = 100;

export const ENDPOINT_RELATED_WEBPAGES_MAX_LIMIT = 100;
